import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ROLES } from '../../utils/constants';

const Sidebar = () => {
  const { user } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  const adminLinks = [
    { to: '/dashboard', label: 'Dashboard', icon: '📊' },
    { to: '/admins', label: 'Administrateurs', icon: '👥' },
    { to: '/owners', label: 'User Owners', icon: '👤' },
    { to: '/simples', label: 'User Simples', icon: '🧑' },
    { to: '/devices', label: 'Devices Tuya', icon: '🔌' },
    { to: '/associations', label: 'Associations', icon: '🔗' },
    { to: '/consumption/global', label: 'Consommation Global', icon: '⚡' },
    { to: '/logs', label: 'Logs', icon: '📝' },
  ];

  const ownerLinks = [
    { to: '/dashboard', label: 'Dashboard', icon: '📊' },
    { to: '/my-associations', label: 'Mes Associations', icon: '🔗' },
    { to: '/my-simples', label: 'Mes Simples', icon: '🧑' },
    { to: '/logs', label: 'Activités', icon: '📝' },
  ];

  const simpleLinks = [
    { to: '/dashboard', label: 'Dashboard', icon: '📊' },
    { to: '/my-consumption', label: 'Ma Consommation', icon: '⚡' }, // ← NOUVEAU
    { to: '/profile', label: 'Mon Profil', icon: '👤' },
  ];

  let links = [];
  if (user?.role === ROLES.ADMIN) links = adminLinks;
  else if (user?.role === ROLES.OWNER) links = ownerLinks;
  else if (user?.role === ROLES.SIMPLE) links = simpleLinks;

  return (
    <>
      {/* Bouton hamburger (mobile uniquement) */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 p-2 bg-white rounded-lg shadow-lg"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          {isOpen ? (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          ) : (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          )}
        </svg>
      </button>

      {/* Overlay (mobile uniquement) */}
      {isOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed lg:sticky top-0 left-0 z-40
          w-64 bg-white shadow-lg min-h-screen
          transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
          overflow-y-auto
        `}
      >
        <div className="p-6">
          <nav className="space-y-2 mt-16 lg:mt-0">
            {links.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                onClick={() => setIsOpen(false)}
                className={({ isActive }) =>
                  `flex items-center space-x-3 px-4 py-3 rounded-lg transition ${
                    isActive
                      ? 'bg-gradient-blue text-white'
                      : 'text-gray-700 hover:bg-blue-light'
                  }`
                }
              >
                <span className="text-xl">{link.icon}</span>
                <span className="font-semibold text-sm lg:text-base">{link.label}</span>
              </NavLink>
            ))}
          </nav>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;